export const save = {
    status: 0,
    details: {
        payment_information_saved: 1
    }
};